import { ELECTRON_MODE } from "@constants";

import React from "react";

import { useCard, useSocketConnection, useSteps } from "@hooks/.";

import { TechnicalProblemModalWrapper } from "@components/common/TechnicalProblemModalWrapper";
import { TimeoutLogic } from "@components/IdleDetection";
import { AuthenticationModalWrapper } from "@components/LocalSettings/AuthenticationModalWrapper";
import { LocalConfigModalWrapper } from "@components/LocalSettings/LocalConfigModalWrapper";
import { TechnicalProblemModal } from "@components/TechnicalProblemModal";

import { LogoutProblemModal } from "@pages/Kiosk/LogoutProblemModal";
import { StepComponent } from "@pages/Kiosk/Steps/StepComponent";
import { UserAccountModalWrapper } from "@pages/Kiosk/UserAccountModalWrapper";

import { HelpModalWrapper } from "../HelpModalWrapper";
import "./transitions.css";

export function Steps(): JSX.Element {
    useSteps();
    useCard();
    useSocketConnection();

    React.useEffect(() => {
        // eslint-disable-next-line
        if (process.env.REACT_APP_MODE === ELECTRON_MODE) {
            (window as RendererWindow).electronAPI?.checkKioskModeEvent();
        }
    });

    return (
        <React.Fragment>
            <AuthenticationModalWrapper />
            <LocalConfigModalWrapper />
            <TimeoutLogic />
            <HelpModalWrapper />
            <UserAccountModalWrapper />
            <TechnicalProblemModalWrapper />
            <TechnicalProblemModal />
            <LogoutProblemModal />
            <StepComponent />
        </React.Fragment>
    );
}
